import React from "react";
import { CornerUpLeft } from "lucide-react";
import { useNavigate, useSearchParams } from "react-router";
import { useDroppable } from "@dnd-kit/core";
import { FolderItem } from "@/types/fse";
import { ROOT_DRIVE_NAME } from "@/views/drive/consts";
import { supplierContractFamilySearch } from "@/views/drive/supplierContractFamilyNavigation";

interface HomeRowProps {
  parentFolder: FolderItem | null;
}

const HomeRow: React.FC<HomeRowProps> = ({ parentFolder }) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  // dnd-kit droppable hook for HomeRow - must be called before early return
  const { isOver: isDropOver, setNodeRef: setDroppableRef } = useDroppable({
    id: parentFolder ? `home-row-droppable-${parentFolder.id}` : "home-row-disabled",
    data: {
      parentFolder,
      isHomeRow: true,
    },
    disabled: !parentFolder || !parentFolder.id,
  });

  if (!parentFolder || !parentFolder.id) {
    return null;
  }

  const handleNavigation = () => {
    const parentPath = parentFolder.current_location.path;
    const isDriveRoot =
      parentFolder.name === ROOT_DRIVE_NAME &&
      ((parentPath.length === 1 && parentPath[0]?.id === parentFolder.id) ||
        (parentPath.length === 0 && parentFolder.parent_fs_id === null));

    const path = isDriveRoot ? "/drive" : `/drive/${parentFolder.id}`;
    navigate(`${path}${supplierContractFamilySearch(searchParams)}`);
  };

  return (
    <button
      type="button"
      ref={setDroppableRef}
      className={`flex w-full cursor-pointer items-center p-4 py-6 text-left hover:bg-gray-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 ${
        isDropOver ? "border-2 border-dashed border-blue-300 bg-blue-50" : ""
      }`}
      onClick={handleNavigation}
    >
      <CornerUpLeft className="mr-2 h-5 w-5 text-gray-500" />
      <span className="font-medium text-gray-500">{parentFolder.name}</span>
      {isDropOver && <span className="ml-auto text-xs font-medium text-blue-600">Drop to move here</span>}
    </button>
  );
};

export default HomeRow;
